import React from 'react';

interface Project {
    id: number;
    name: string;
    description: string | null;
    status: string;
}

interface Rechnung {
    id: number;
    amount: number;
    date: string;
    projectId: number;
    project?: Project;
}

interface RechnungInfoCardProps {
    rechnung: Rechnung;
}

const RechnungInfoCard: React.FC<RechnungInfoCardProps> = ({ rechnung }) => {
    const formatCurrency = (amount: number): string => {
        return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
        }).format(amount / 100);
    };

    const formatDate = (dateString: string): string => {
        return new Date(dateString).toLocaleDateString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    };

    return (
        <div className="rechnung-info-card">
            <h2>Rechnungsinformationen</h2>
            <div className="info-grid">
                <div className="info-item">
                    <span className="info-label">Rechnungs-ID:</span>
                    <span className="info-value">{rechnung.id}</span>
                </div>
                <div className="info-item">
                    <span className="info-label">Datum:</span>
                    <span className="info-value">{formatDate(rechnung.date)}</span>
                </div>
                <div className="info-item">
                    <span className="info-label">Gesamtbetrag:</span>
                    <span className="info-value amount-highlight">{formatCurrency(rechnung.amount)}</span>
                </div>
                {rechnung.project && (
                    <div className="info-item">
                        <span className="info-label">Projekt:</span>
                        <span className="info-value">{rechnung.project.name}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RechnungInfoCard;
